import { createStyles } from '@mantine/core'

export default createStyles((theme, _params, getRef) => ({
  root: {
    margin: '8px 20px 20px',
    minHeight: '56px',
  },
}))
